import {type ActionTree} from 'vuex';

const actions: ActionTree<ISessionserviceState, RootState> = {
    fetchResourceData({
        commit,
        dispatch,
    }, {
        resource,
        options = {},
    }: SessionserviceFetchDataOptions)
    {
        let getPageOptions = {} as GetPageOptions;
        for (const optionsKey in options)
        {
            if (!options.hasOwnProperty(optionsKey))
            {
                continue;
            }

            getPageOptions[optionsKey] = options[optionsKey];
        }

        getPageOptions.url = '/' + resource + '/fetch-data';

        return this.dispatch('getPage', getPageOptions).then((response) =>
        {
            const data = response.data?.data;
            if (data)
            {
                commit('setData', data);
            }
        });
    },

    setEditActiveTopic({commit}, topic: string)
    {
        commit('setEditActiveTopic', topic);
    },

};

export default actions;